import { Link } from "react-router-dom";
import { articles, type ArticleItem } from "@/mocks/articles";
import { categories } from "@/mocks/categories";

export const formatCount = (n: number) => (n > 999 ? `${(n / 1000).toFixed(1)}k` : `${n}`);

export function useTopHot(limit = 6): ArticleItem[] {
  return [...articles].sort((a, b) => b.hot - a.hot).slice(0, limit);
}

export function byCat(cat?: string | null): ArticleItem[] {
  if (!cat || cat === "all") return articles;
  return articles.filter((a) => a.cat === cat);
}

export function findCatName(id: string) {
  return categories.find((c) => c.id === id);
}

export function PopularTopics() {
  return (
    <div className="mt-6 flex flex-wrap gap-2">
      {categories.map((c) => (
        <Link
          key={c.id}
          to={`/library?cat=${c.id}`}
          className="flex items-center gap-2 whitespace-nowrap rounded-full bg-background-100 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-800"
        >
          <i className={`${c.icon} text-primary-600`}></i>
          {c.name}
        </Link>
      ))}
    </div>
  );
}